/**
 * Apparat modellari reyestri: lab JSON dagi `unit` → UnitModel.
 * Tiplar bu yerda "yo'qotiladi" (unknown), chunki lab ta'rifi ma'lumot;
 * har model o'z params/inputs ni `validateParams` bilan tekshiradi.
 */
import type { UnitModel } from '../types';
import { setParamsResolver } from './variant';
import { heatExchanger } from '../units/heat-exchanger';
import { rectificationColumn } from '../units/rectification';
import { absorber } from '../units/absorber';
import { cstr } from '../units/cstr';
import { pfr } from '../units/pfr';
import { filtration } from '../units/filtration';
import { convectiveDryer } from '../units/dryer';
import { pumpPipeline } from '../units/pump-pipeline';
import { flowsheetUnit } from '../units/flowsheet';
import { evaporator } from '../units/evaporator';
import { centrifuge } from '../units/centrifuge';

export type AnyUnitModel = UnitModel<unknown, unknown, unknown, unknown, unknown>;

const registry = new Map<string, AnyUnitModel>();

export function registerUnit(model: AnyUnitModel): void {
  registry.set(model.id, model);
}

export function getUnit(id: string): AnyUnitModel {
  const m = registry.get(id);
  if (!m) throw new Error(`Unknown unit model: ${id}`);
  return m;
}

export function unitIds(): string[] {
  return [...registry.keys()];
}

for (const m of [
  heatExchanger,
  rectificationColumn,
  absorber,
  cstr,
  pfr,
  filtration,
  convectiveDryer,
  pumpPipeline,
  flowsheetUnit,
  evaporator,
  centrifuge,
]) {
  registerUnit(m);
}

// Lab parametrlarini apparat modeli orqali ochish (variant.ts hook)
setParamsResolver((unit, params) => {
  const m = registry.get(unit);
  return m?.resolveParams ? (m.resolveParams(params) as Record<string, unknown>) : params;
});
